import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {UserService} from '../user/user-service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'dk-popup',
    template: require('./chf_popup.html'),
    providers: [ UserService ],
    styleUrls: [ 'web/bootstrap.min.css' ] 
})

export class ModalContentComponent implements OnInit{
    @Output() closeModalEvent = new EventEmitter<boolean>();

    allChecked = false;
    accept1 = false;
    accept2 = false;
    accept3 = false;

    constructor(public activeModal: NgbActiveModal, private userService: UserService) { }
    
    ngOnInit() {  }
    
    accept(): void {
        this.sendResponse(true);
    }

    decline(): void {
        this.sendResponse(false);
    }

    private sendResponse(accept){
        this.userService.acceptOffer(1, accept).subscribe(result => {
            this.activeModal.close();
        });
    }

    close() {
        this.activeModal.close();
    }

    later() {
        this.activeModal.close();
    }

    checkAll(): void {
        this.allChecked = this.accept1 && this.accept2 && this.accept3;
    }
  }
